module.exports = __webpack_public_path__ + "img/icon-onboarding-payment.5cfdd89f.svg";